import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import styles from "./index.module.css";

const CustomPopup = ({
  open,
  title,
  children,
  onClose,
  onActionClick,
  actionButtonLabel = "Submit",
  closeButtonLabel = "Close",
  isLoading = false,
  width = "610px",
  isActionButtonDisabled = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        style: {
          width: width,
          fontFamily: "'Roboto', sans-serif",
        },
      }}
    >
      <DialogTitle
        className={styles.dialogTitle}
        style={{
          textAlign: "center",
          position: "relative",
          marginTop: "20px",
          padding: "0px",
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent className={styles.dialogContent}>{children}</DialogContent>

      <DialogActions className={styles.dialogActions}>
        <Button onClick={onClose} className={styles.closeButton}>
          {closeButtonLabel}
        </Button>
        <Button
          onClick={onActionClick}
          className={styles.actionButton}
          disabled={isLoading || isActionButtonDisabled}
          style={
            actionButtonLabel.toLowerCase() === "delete"
              ? { backgroundColor: "#FF6647" }
              : { backgroundColor: "#FF712D" }
          }
        >
          {isLoading ? "Loading..." : actionButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomPopup;
